if (!customElements.get("media-gallery")) {
  customElements.define(
      "media-gallery",
      class MediaGallery extends HTMLElement {
          constructor() {
              super();

              const parentCloset = this.closest("quick-add-modal");
              let optionsThumbnail = {};
              if (this.dataset.type == "main") {
                  optionsThumbnail = {
                      slidesPerView: 4,
                      spaceBetween: 8,
                      direction: parentCloset ? "horizontal" : "vertical",
                      watchOverflow: true,
                      mousewheel: true,
                      breakpoints: {
                          990: {
                              slidesPerView: "auto",
                          },
                      },
                      navigation: {
                          nextEl: this.querySelector(".swiper-thumbnail .swiper-button-next"),
                          prevEl: this.querySelector(".swiper-thumbnail .swiper-button-prev"),
                      },
                      on: {
                          resize: () => {
                              this.swiperThumbs.changeDirection(this.getDirection());
                          },
                      },
                  };
              } else if (this.dataset.type == "modal") {
                  optionsThumbnail = {
                      slidesPerView: "auto",
                      spaceBetween: 8,
                      watchOverflow: true,
                      centerInsufficientSlides: true,
                  };
              }
              this.swiperThumbs = new Swiper(this.querySelector(".swiper-thumbnail"), optionsThumbnail);
              this.swiperMain = new Swiper(this.querySelector(".swiper-main"), {
                  slidesPerView: 1,
                  thumbs: {
                      swiper: this.swiperThumbs,
                  },
                  pagination: {
                      el: this.querySelector(".swiper-pagination"),
                  },
                  navigation: {
                      nextEl: this.querySelector(".swiper-main ~ .swiper-button-next"),
                      prevEl: this.querySelector(".swiper-main ~ .swiper-button-prev"),
                  },
              });
          }

          swiperSlideTo(index) {
              this.swiperMain.slideTo(index);
          }

          getDirection() {
            const parentCloset = this.closest("quick-add-modal");
            if(parentCloset) return "horizontal";
            let windowWidth = window.innerWidth;
            let direction = windowWidth < 990 ? "horizontal" : "vertical";
            return direction;
          }
      }
  );
}